// PRO-671. The keys are the reserved `system_*` variable names the engine reads; they are hidden from the
// Variables table, so this screen is the only place they are edited.
export const AGENT_SETTING_KEYS = Object.freeze({
  NAME: 'system_agent_name',
  GENDER: 'system_agent_gender',
  ROLE: 'system_agent_role',
  COMPANY: 'system_agent_company',
  FORMALITY: 'system_agent_formality',
  EMOJI: 'system_agent_emoji',
  REPLY_LENGTH: 'system_agent_reply_length'
})

// '' is a real choice, not a placeholder: an unset control states nothing in the prompt rather than asserting
// a default the customer never picked.
const UNSET = { value: '', text: 'Not set' }

export const GENDER_OPTIONS = [UNSET, { value: 'female', text: 'Female' }, { value: 'male', text: 'Male' }]

export const FORMALITY_OPTIONS = [UNSET, { value: 'formal', text: 'Formal' }, { value: 'informal', text: 'Informal' }]

export const EMOJI_OPTIONS = [
  UNSET,
  { value: 'none', text: 'No emojis' },
  { value: 'moderate', text: 'In moderation' },
  { value: 'frequent', text: 'Freely' }
]

export const REPLY_LENGTH_OPTIONS = [
  UNSET,
  { value: 'short', text: 'Short and to the point' },
  { value: 'detailed', text: 'Detailed, with reasoning' }
]
